import React, { useCallback, useEffect, useState } from 'react'
import { createMessage } from '../../utilities/utilities';
import { Container } from 'react-bootstrap';
import PageTitle from './../shared/PageTitle';
import { addUser, allUsers, oneUser, removeUser, updateUser } from '../../services/users';
import { handleError } from '../../utilities/errorHandler';
import Message from '../shared/Message';
import UsersTable from '../tables/UsersTable';
import CustomLoader from './../shared/CustomLoader';
import UserForm from './../forms/UserForm';

const Users = () => {
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({
        text: '', 
        variant: '',
        show: false
    });

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const [users, setUsers] = useState([]);
    const [user, setUser] = useState(null);

    const getUsers = useCallback(async () => {
        
        setIsLoading(true);
        try {
            const response = await allUsers();
            if (response.status === 200){
                setUsers(response.data);
            }
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setIsLoading(false);
        }
    }, []);

    const getUser = (id) => {
        oneUser(id).then((response) => {
            if(response.status === 200){
                setUser(response.data);
            }
        }).catch(error => {
            const errorMessage = handleError(error);
            if(errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        });
    }

    const deleteUser = (id) => {
        try {
            removeUser(id);
            handleMessage('User successfully deleted.', 'success');
            getUsers();
        } catch(error) {
            const errorMessage = handleError(error);
            if(errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        }
    }

    useEffect(() => {
        getUsers();
    }, [getUsers]);

    const saveUser = async (data) => {
        setIsSaving(true);

        try {
            const userData = {
                name: data.name,
                email: data.email,
                phone: data.phone,
                username: data.username,
                role: data.role.value
            };

            if (data.id){
                await updateUser(data.id, userData);
                handleMessage('User successfully updated', 'success');
                getUsers();

                return true;
            } else {
                await addUser(userData);
                handleMessage('User successfully saved', 'success');
                getUsers();

                return true;
            }
        } catch (error) {
            console.error(error);
            try {
                const errorMessage = handleError(error);
                if (errorMessage){
                    handleMessage(errorMessage.text, 'danger');
                }
            } catch (e){
                // error will handled by onSubmit() in UserForm.jsx 
                throw e;
            }
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    }

  return (
    <Container fluid>

        <PageTitle title='User Details' />

        {message.show && (
            <Message 
                message={message.text} 
                variant={message.variant} 
                show={message.show} 
                handleClose={handleCloseMessage} 
            />
        )}

        <UserForm
            isSaving={isSaving}
            formAction={saveUser}
            user={user}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <UsersTable
                    users={users}
                    onDelete={deleteUser}
                    onEdit={getUser}
                />
            )
        }

    </Container>
  )
}

export default Users